import React, { useEffect, useState } from 'react';
import * as styles from './ContextHelp.css.ts';

export interface SmartHintData {
  id: string;
  title: string;
  content: React.ReactNode;
  icon?: string;
  duration?: number; // milliseconds, default 5000
}

interface SmartHintProps {
  hint: SmartHintData;
  onClose: () => void;
}

export const SmartHint: React.FC<SmartHintProps> = ({ hint, onClose }) => {
  const [isHiding, setIsHiding] = useState(false);

  useEffect(() => {
    const duration = hint.duration || 5000;
    const timer = setTimeout(() => {
      setIsHiding(true);
      setTimeout(onClose, 300); // Wait for animation
    }, duration);

    return () => clearTimeout(timer);
  }, [hint, onClose]);

  const handleClose = () => {
    setIsHiding(true);
    setTimeout(onClose, 300);
  };

  return (
    <div className={`${styles.smartHint} ${isHiding ? styles.hiding : ''}`}>
      <div className={styles.smartHintHeader}>
        <div className={styles.smartHintTitle}>
          {hint.icon && <span>{hint.icon}</span>}
          {hint.title}
        </div>
        <button
          className={styles.smartHintClose}
          onClick={handleClose}
          aria-label="Close hint"
        >
          ✕
        </button>
      </div>
      <div className={styles.smartHintContent}>
        {hint.content}
      </div>
    </div>
  );
};